import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoPurpleIcon from '../../../assets/icons/info-purple.svg';
import './InfoLinkModal.less';

export type InfoLinkModalProps = {
  onClose: () => void;
};

const InfoLinkModal: React.FC<InfoLinkModalProps> = ({ onClose }) => {
  const { t } = useTranslation();

  const handleOverlayClick = () => onClose?.();
  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation();

  return (
    <div className="info-link-overlay" onClick={handleOverlayClick}>
      <div className="info-link-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>
        <div className="info-link-container">
          <img src={InfoPurpleIcon} className="info-link-icon" alt="Info" />
          <div className="info-link-title">{t('info-link-title')}</div>
          <div className="info-link-desc">{t('info-link-desc')}</div>
          <button type="button" className="info-link-button" onClick={onClose}>
            {t('i-understand')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InfoLinkModal;
